<template>
  <v-container fluid grid-list-md text-xs-center>
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <v-toolbar class="primary white--text">
          <v-toolbar-title class="text-xs-center">
            <router-link
              style="text-decoration: none"
              :to="{ name: 'Dashboard' }"
            >
              <b class="title primary white--text"> Manage Order </b>
            </router-link>
          </v-toolbar-title>
          <v-spacer />
          <v-select
            solo
            clearable
            v-model="selectedCustomer"
            :items="getOrderedCustomers"
            label="Buyers"
          >
          </v-select>
          <v-spacer />
          <v-select
            solo
            clearable
            v-model="statusFilter"
            :items="['IN PROGRESS', 'CANCELLED', 'BILLED', 'ALL']"
            label="Filter"
          >
          </v-select>

          <!-- class="status-filter" -->
          <v-spacer></v-spacer>
                <v-menu
                  :close-on-content-click="false"
                  v-model="datepickerFrom"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  class="white-datepicker"
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="dateFrom"
                    label="From Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="dateFrom"
                    @input="datepickerFrom = false"
                  ></v-date-picker>
                </v-menu>
              <v-spacer/>
                <v-menu
                  :close-on-content-click="false"
                  v-model="datepickerTo"
                  :nudge-right="40"
                  lazy
                  class="white-datepicker"
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="dateTo"
                    label="To Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="dateTo"
                    @input="datepickerTo = false"
                  ></v-date-picker>
                </v-menu>
          <router-link
            style="text-decoration: none"
            :to="'informations/product-order-report/'"
          >
            <v-btn outlined  v-if="!isRestaurantBusiness">
              <v-icon left class="primary--text">mdi-alert-box</v-icon> Order
              Product
            </v-btn>
          </router-link>
          <v-spacer></v-spacer>
          <v-btn outlined  v-if="isRestaurantBusiness" @click="viewTable()">
            <v-icon left color="primary">remove_red_eye</v-icon> View Tables
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn outlined @click="addOrderDialog()">
            <v-icon left color="primary">add</v-icon> New Order
          </v-btn>
        </v-toolbar>
          <v-layout row wrap v-if="isRestaurantBusiness">
                <!-- <v-flex xs2 sm2 md2>
                    <v-switch
                        v-model="allOrderFilter"
                        :label="`${allOrderFilter ? 'All Orders' : 'Today Order'}`"
                    ></v-switch>
                </v-flex> -->
                <v-flex xs2 sm2 md2>
                    <v-btn outlined @click="kitchenDialog = true">
                      <v-icon left color="primary">fastfood</v-icon> Kitchen Screen
                    </v-btn>
                </v-flex>
                <v-flex xs2 sm2 md2>
                  <v-select
                    solo
                    clearable
                    v-model="orderTypeFilter"
                    :items="['Normal', 'Parcel', 'All']"
                    label="Type"
                  >
                  </v-select>
                </v-flex>
          </v-layout>

        <v-data-table
          :headers="orderHeader"
          :items="filteredOrders"
          hide-actions
          class="elevation-1 dashboardHead"
        >
          <template slot="items" slot-scope="props">
            <td>
              <v-menu bottom right offset-y :close-on-content-click="false">
                <v-btn class="mx-0" slot="activator" icon dark>
                  <v-icon color="primary">more_vert</v-icon>
                </v-btn>
                <v-list>
                  <v-list-group :prepend-icon="'picture_as_pdf'" no-action>
                    <template v-slot:activator>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>Actions</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </template>

                    <v-list-tile
                      v-if="props.item['orderHistory']"
                      @click="openHistory(props.item)"
                      color="primary"
                    >
                      <v-list-tile-avatar>
                        <v-icon color="primary">history</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-title>Processed Order</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile
                      v-if="props.item['orignalOrder']"
                      @click="openOrignal(props.item)"
                      color="primary"
                    >
                      <v-list-tile-avatar>
                        <v-icon color="primary">trip_origin</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-title> Original Order </v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile
                      v-if="props.item['status'] == 'IN PROGRESS' && hasOrderEditPermission"
                      @click="editOrder(props.item)"
                    >
                      <v-list-tile-avatar>
                        <v-icon color="primary">edit</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-title>Add/Edit Order</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile 
                      v-if="props.item['status'] == 'IN PROGRESS'  && hasOrderDeletePermission"
                      @click="deleteOrder(props.item)">
                      <v-list-tile-avatar
                        >
                        <v-icon color="primary">delete</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-title>Delete Order</v-list-tile-title>
                    </v-list-tile>
                  </v-list-group>
                </v-list>
              </v-menu>
            </td>
            <td>
              <!-- <v-icon :disabled="props.item['status']=='CANCELLED' || props.item['status']=='BILLED'" @click="openProd(props.item)" color="primary">remove_red_eye</v-icon> -->
              <v-icon
                :disabled="
                  props.item['status'] == 'CANCELLED' ||
                  props.item['status'] == 'BILLED' ||
                  (getCustomerName(props.item.buyerId) == 'DELETED CUSTOMER'
                    ? isShopUserExists(props.item.shopOrderUserId)
                      ? false
                      : true
                    : false)
                "
                @click="openProd(props.item)"
                color="primary"
                >remove_red_eye</v-icon
              >
            </td>
            <td>
              <b>
                {{ props.item["tableName"] }}
              </b>
            </td>
            <td>
              <b
                >{{ props.item["orderNumber"] }} -
                {{ props.item["orderType"] }}</b
              >
            </td>
            <td>
              <b>{{ new Date(props.item.date).toLocaleDateString("en-GB") || '-' }}</b>
            </td>
            <td>
              <b>{{new Date(props.item.time).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}}</b>
            </td>
            <td>
              <b v-if="props.item.buyerId">{{
                getCustomerName(props.item.buyerId)
              }}</b>
              <b v-else-if="isShopUserExists(props.item.shopOrderUserId)">{{
                getShopUserName(props.item.shopOrderUserId)
              }}</b>
              <b v-else>
                <v-btn @click="addShopUser(props.item)">{{
                  props.item.shopOrderUserName
                }}</v-btn>
                <br />
                <div>New Customer. Click To Create Buyer.</div>
              </b>
            </td>
            <td>
              <b>{{
                props.item["invoiceDate"]
                  ? new Date(props.item.invoiceDate).toLocaleDateString("en-GB")
                  : ""
              }}</b>
            </td>
            <td>
              <b class="font-weight-bold red--text">{{
                getTotal(props.item) || 0 | amount
              }}</b>
            </td>
            <!-- <td>
              <b>{{props.item['remainingAmountOrder']}}</b>
            </td> -->
            <!-- <td>
              <b>{{props.item['.key']}}</b>
            </td> -->
            <!-- <td>
              <b>{{getFirmName(props.item.firm)}}</b>
            </td> -->
            <td>
              <b>{{ props.item["status"] }}</b>
            </td>
            <td v-if="props.item['status'] != 'CANCELLED'">
              <v-btn
                v-if="props.item['status'] == 'IN PROGRESS'"
                icon
                class="mx-0"
                @click="cancelOrder(props.item)"
              >
                <v-icon color="pink">cancel</v-icon>
              </v-btn>
              <v-btn
                v-else
                icon
                class="mx-0"
                @click="dispatrchOrder(props.item)"
              >
                <v-icon color="pink">commute</v-icon>
              </v-btn>
            </td>
            <td v-else></td>
            <td>
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" icon class="mx-0">
                    <v-icon color="blue">print</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-tile @click="printOrder(props.item, true)">
                    <v-list-tile-title> Taxable Print </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="printOrder(props.item, false)">
                    <v-list-tile-title> Simple Print </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile v-for="i in getOrders(props.item)" :key="i">
                    <v-list-tile @click="printOrder(props.item, false, i)">
                      <v-list-tile-title>Call- {{ i }} </v-list-tile-title>
                    </v-list-tile>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </td>
            <!-- <td>
              <v-icon v-if="props.item['orderHistory']" @click="openHistory(props.item)" color="primary">history</v-icon>
            </td>
              <td>
              <v-icon v-if="props.item['orignalOrder']" @click="openOrignal(props.item)" color="primary">trip_origin</v-icon>
            </td>
            <td>
              <v-btn icon class="mx-0" v-if="props.item['status'] == 'IN PROGRESS'" @click="editOrder(props.item)">
                <v-icon color="pink">edit</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn icon class="mx-0" @click="deleteOrder(props.item)">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td> -->
          </template>
          <template slot="no-data">No Items</template>
        </v-data-table>
      </v-flex>
    </v-layout>

    <!-- Start Product Transfer Dialog -->
    <v-dialog v-model="orderDialog" fullscreen persistent>
      <v-card persistent>
        <v-card-title class="primary white--text">
          <!-- <span class="headline">Create Order</span> -->
          <span class="headline" v-if="isEdit">Edit Order</span>
          <span class="headline" v-else>Create Order</span>
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm3 md3>
                <v-switch
                  :disabled="isEdit"
                  v-model="isBuyer"
                  :label="`${isBuyer ? 'Sale Order' : 'Purchase Order'}`"
                ></v-switch>
              </v-flex>
              <v-spacer />
              <v-flex xs12 sm3 md3>
                <v-switch
                  :disabled="isEdit"
                  v-model="multiFirm"
                  @change="restructureProductList()"
                  :label="`Multi-firm`"
                ></v-switch>
              </v-flex>
              <v-spacer />
              <v-flex xs12 sm4 md4>
                <v-select
                  dense
                  :disabled="multiFirm"
                  :items="firmsByBrand"
                  label="Select Firm"
                  v-model="selectedFirm"
                ></v-select>
              </v-flex>

              <v-flex xs12 sm4 md4>
                <v-select
                  v-bind:items="isBuyer ? buyersByBrand : sellersByBrand"
                  v-model="selectedBuyer"
                  :label="
                    isBuyer ? 'Select or add Customer' : 'Select or add Seller'
                  "
                  autocomplete
                  :disabled="isEdit"
                  item-text="name"
                  return-object
                  @keyup.native.enter="addCustomer"
                >
                </v-select>
              </v-flex>
              <v-spacer />
              <v-flex xs12 sm3 md3> </v-flex>
              <v-spacer />
              <v-flex xs12 sm3 md3>
                <v-menu
                  :close-on-content-click="false"
                  v-model="datepickerOrder"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="date"
                    label="Order Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="date"
                    @input="datepickerOrder = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm1 md1>
                <v-text-field
                  v-model="orderNumber"
                  prefix="#"
                  label="Order Number"
                  placeholder="Enter Order Number"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm2 md2>
                <v-select
                  item-text="name"
                  item-value="id"
                  :items="currentOrderType"
                  v-model="orderType"
                  label="Choose Order Type"
                ></v-select>
              </v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-if="ordersSetting && ordersSetting.isOrderTime"
              >
                <v-time-picker
                  label="Order Time"
                  v-model="orderTime"
                ></v-time-picker>
              </v-flex>
              <v-flex
                xs12
                sm3
                md3
                v-if="ordersSetting && ordersSetting.isStaffSelection"
              >
                <v-select
                  v-if="orderType==='Normal'"
                  dense
                  :items="staffByBrand"
                  label="Sold By"
                  v-model="soldBy"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm3 md3 v-if="isRestaurantBusiness && !multiFirm">
                <v-select
                  v-if="orderType==='Normal'"
                  dense
                  :items="floorList"
                  label="Select Floor"
                  item-text="name"
                  item-value="name"
                  @change="
                    getTableList();
                    getFloorList();
                  "
                  v-model="floorName"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm2 md2 v-if="tableList.length">
                <v-select
                  dense
                  :items="tableList"
                  label="Select Table"
                  item-text="name"
                  item-value="name"
                  v-model="tableName"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm2 md2 v-if="tableName && floorName">
                <v-btn
                  color="green darken-4"
                  v-if="!isTabOccupied"
                  @click="changeTableStatus(true)"
                  flat
                  >Book Table</v-btn
                >
                <v-btn
                  color="red darken-4"
                  v-else
                  @click="changeTableStatus(false)"
                  flat
                  >Release Table</v-btn
                >
              </v-flex>
              <v-flex xs12 sm12 md12>
                <!-- <v-combobox
                  v-model="productsToOrder"
                  :items="productListByBrand"
                  :return-object="true"
                  item-text="name"
                  @change="addToBucket()"
                  label="Select Product"
                  multiple
                ></v-combobox> -->
              </v-flex>

              <v-flex xs12 sm12 md12>
                <v-layout wrap>
                  <template v-for="(item, index) in items">
                    <v-flex
                      :key="index + item.productId"
                      xs4
                      sm4
                      md4
                      style="display: inline-flex"
                    >
                      <v-select
                        style="width: 90%"
                        dense
                        autocomplete
                        item-text="name"
                        :item-value="'name'"
                        :items="productListByBrand"
                        label="Product Name"
                        v-model="item.productName"
                        @change="restructureProductList(index)"
                      ></v-select>
                      <v-text-field
                        style="width: 10%"
                        v-if="isRestaurantBusiness"
                        disabled
                        type="number"
                        v-model="item.call"
                        label="Call"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex :key="index + item.productName" xs1 sm1 md1>
                      <v-text-field
                        v-if="item.productName"
                        type="number"
                        v-model.number="item.quantity"
                        label="Quantity"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs2 sm2 md2 :key="index + item.unit">
                      <v-select
                        v-if="item.productName"
                        dense
                        item-text="text"
                        item-value="value"
                        :items="availableProductUnit[item.productId].units"
                        @change="unitChange(item)"
                        label="Select unit"
                        v-model="item.unit"
                      ></v-select>
                    </v-flex>
                    <v-flex
                      :key="index + item.productName + 'RATE'"
                      xs2
                      sm2
                      md2
                    >
                      <v-text-field
                        v-if="item.productName"
                        type="number"
                        :disabled="!hasOrderRateEditPermission"
                        v-model.number="item.rate"
                        label="Rate"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex
                      :key="index + item.productName + 'total'"
                      xs2
                      sm2
                      md2
                    >
                      <v-text-field
                        v-if="item.productName"
                        type="number"
                        :value="
                          Number.parseFloat(
                            (item.rate ? Number.parseFloat(item.rate) : 0) *
                              (item.rate ? Number.parseFloat(item.quantity) : 0)
                          ).toFixed(2)
                        "
                        :disabled="true"
                        label="Total"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex :key="index + item.productName + 'add'" xs1 sm1 md1>
                      <v-btn
                        icon
                        color="primary"
                        @click="removeProd(index)"
                        v-if="item.productName"
                      >
                        <v-icon>cancel</v-icon>
                      </v-btn>
                      <v-btn
                        icon
                        color="primary"
                        v-if="index == items.length - 1 && item.productName"
                        @click="addProd()"
                      >
                        <v-icon>add_circle</v-icon>
                      </v-btn>
                    </v-flex>
                  </template>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" @click="orderDialog = false" flat
            >Cancel</v-btn
          >
          <v-btn
            color="blue darken-1"
            :disabled="
              !items.length ||
              !selectedBuyer ||
              !items[0].productId ||
              (multiFirm ? false : !selectedFirm)
            "
            @click="addOrder()"
            flat
            >{{ isEdit ? "Save" : "Create" }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="invoiceOrder"
      width="800"
      v-if="selectedOrder && selectedOrder['.key']"
    >
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title
          >Order details:-
          <!-- {{selectedOrder['.key']}} -->
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="productInvoiceHeader"
            :items="selectedOrder.items"
            class="elevation-1 dashboardHead"
          >
            <template slot="items" slot-scope="props">
              <tr :class="props.item.completed ? 'green-bg' : ''">
                <td v-if="isRestaurantBusiness">
                  <b>{{ props.item["call"] }}</b>
                </td>
                <td>
                  <b>{{ props.item["productName"] }}</b>
                </td>
                <td>
                  <b>{{ props.item["quantity"] }}</b>
                </td>
                <td>
                  <b>{{ props.item.unit }}</b>
                </td>
                <td>
                  <b
                    ><v-text-field
                      type="number"
                      v-model.number="props.item.rate"
                      :disabled="!hasOrderRateEditPermission"
                      label="Product Rate"
                    ></v-text-field
                  ></b>
                </td>
                <td>
                  <v-text-field
                    type="number"
                    :value="
                      (props.item.rate
                        ? Number.parseFloat(props.item.rate)
                        : 0) *
                      (props.item.rate
                        ? Number.parseFloat(props.item.quantity)
                        : 0)
                    "
                    :disabled="true"
                    label="Total"
                  >
                  </v-text-field>
                </td>
              </tr>
            </template>
            <template slot="no-data">No Items</template>
          </v-data-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="primary" text @click="invoiceOrder = false">Back</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="createInvoice()"
            >Create Invoice
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="orderHistory"
      width="800"
      v-if="selectedOrder && selectedOrder['.key']"
    >
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title
          >{{
            modalMode == "history"
              ? "Proceesed Order History:-"
              : "Orignal Order:- "
          }}
          <!-- {{selectedOrder['.key']}} -->
        </v-card-title>
        <v-card-text>
          <template v-if="modalMode == 'orignal'">
            <v-data-table
              :headers="productInvoiceHeader"
              :items="selectedOrder.orignalOrder"
              class="elevation-1 dashboardHead"
            >
              <template slot="items" slot-scope="props">
                <tr :class="props.item.completed ? 'green-bg' : ''">
                  <td v-if="isRestaurantBusiness">
                    <b>{{ props.item["call"] }}</b>
                  </td>
                  <td>
                    <b>{{ props.item["productName"] }}</b>
                  </td>
                  <td>
                    <b>{{ props.item["quantity"] }}</b>
                  </td>
                  <td>
                    <b>{{ props.item.unit }}</b>
                  </td>
                  <td>
                    <b>{{ props.item.rate }}</b>
                  </td>
                  <td>
                    <b>{{
                      (props.item.rate
                        ? Number.parseFloat(props.item.rate)
                        : 0) *
                      (props.item.rate
                        ? Number.parseFloat(props.item.quantity)
                        : 0)
                    }}</b>
                  </td>
                </tr>
              </template>
              <template slot="no-data">No Items</template>
            </v-data-table>
          </template>
          <template v-else>
            <v-stepper v-model="historyStep" vertical>
              <template v-for="(item, index) in selectedOrder.orderHistory">
                <v-stepper-step :step="index + 1" :key="item['.key']">
                  <v-link @click="historyStep = index + 1">{{
                    new Date(item["date"]).toLocaleDateString("en-GB")
                  }}</v-link>
                </v-stepper-step>

                <v-stepper-content :step="index + 1" :key="index + 'a' + item['.key']">
                  <v-card class="mb-12 invoice-stepper">
                    <v-layout row wrap style="padding: 30px">
                      <v-flex xs12 sm4 md4> </v-flex>
                      <v-flex xs12 sm4 md4> </v-flex>
                      <v-flex xs12 sm4 md4> </v-flex>
                      <v-flex xs12 sm12 md12>
                        <h2
                          style="text-decoration: underline; text-align: center"
                        >
                          Product List
                        </h2>
                        <template>
                          <v-data-table
                            :headers="productInvoiceHeader"
                            :items="item.items"
                            class="elevation-1 dashboardHead"
                          >
                            <template slot="items" slot-scope="props">
                              <tr
                                :class="props.item.completed ? 'green-bg' : ''"
                              >
                                <td v-if="isRestaurantBusiness">
                                  <b>{{ props.item["call"] }}</b>
                                </td>
                                <td>
                                  <b>{{ props.item["productName"] }}</b>
                                </td>
                                <td>
                                  <b>{{ props.item["quantity"] }}</b>
                                </td>
                                <td>
                                  <b>{{ props.item.unit }}</b>
                                </td>
                                <td>
                                  <b>{{ props.item.rate }}</b>
                                </td>
                                <td>
                                  <b>{{
                                    (props.item.rate
                                      ? Number.parseFloat(props.item.rate)
                                      : 0) *
                                    (props.item.rate
                                      ? Number.parseFloat(props.item.quantity)
                                      : 0)
                                  }}</b>
                                </td>
                              </tr>
                            </template>
                            <template slot="no-data">No Items</template>
                          </v-data-table>
                        </template>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-stepper-content>
              </template>
            </v-stepper>
          </template>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="primary" text @click="orderHistory = false">Back</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="tableDialog" fullscreen persistent v-if="currentInfra">
      <v-card >
        <!-- <v-card-title class="headline grey lighten-2" primary-title
          >Table Details
        </v-card-title> -->
        <v-card-text>
          <v-tabs v-model="active" color="primary" dark centered>
            <template v-for="floor in currentInfra.floorDetails">
              <v-tab :key="floor.name + 't'">{{ floor.name }}</v-tab>

              <v-tab-item :key="floor.name + 'it'">
                <v-layout row wrap>
                  <v-flex
                    xs12
                    sm2
                    v-for="table in floor.tables"
                    :key="table.name"
                  >
                    <v-card style="padding: 0 10px" height="200px" :class="table.booked ? 'lightgreen-bg' : ''">
                      <v-card-title
                        class="title white lighten-4"
                        height="200px"
                        primary-title
                        >{{ table.name }}
                      </v-card-title>
                       <!-- (No of Sitting : {{ table.capacity }}) -->
                      <v-card-text>
                        <h2
                          class="primary--text font-weight-bold"
                          style="text-align: center; font-size: 18px"
                        >
                          {{ table.booked ? "RESERVED" : "OPEN" }}
                        </h2>
                        <h4 style="text-align: center; font-size: 12px" v-if="table.booked && table.order">
                          {{
                            staffByBrand.find(
                              (i) => i["value"] == table.order.soldBy
                            ).text
                          }}
                        </h4>
                      </v-card-text>
                      <br />
                      <v-card-actions>
                        <v-list-item class="grow">
                          <!-- <v-list-item-content>
                            <v-list-item-title
                              v-if="table.booked && table.order"
                              ><h2>
                                {{
                                  staffByBrand.find(
                                    (i) => i["value"] == table.order.soldBy
                                  ).text
                                }}
                              </h2></v-list-item-title
                            >
                          </v-list-item-content> -->
                          <v-layout
                            align-center
                            justify-end
                            style="margin-top: -20px"
                          >
                            <v-icon
                              class="mr-3 primary--text"
                              v-if="table.booked && table.order"
                              @click="editOrder(table.order)"
                            >
                              add
                            </v-icon>

                            <v-icon
                              class="mr-3 primary--text"
                              v-if="!table.booked"
                              @click="addOrderDialog(table.name,floor.name)"
                            >
                              book
                            </v-icon>

                            <v-menu offset-y v-if="table.booked && table.order">
                              <template v-slot:activator="{ on }">
                                <v-btn v-on="on" icon class="mx-0">
                                  <v-icon class="mr-3 primary--text"
                                    >mdi-receipt</v-icon
                                  >
                                </v-btn>
                              </template>
                              <v-list>
                                <v-list-tile
                                  v-for="i in getOrders(table.order)"
                                  :key="i"
                                >
                                  <v-list-tile
                                    @click="printOrder(table.order, false, i)"
                                  >
                                    <v-list-tile-title
                                      >Call- {{ i }}
                                    </v-list-tile-title>
                                  </v-list-tile>
                                </v-list-tile>
                              </v-list>
                            </v-menu>
                            
                            <v-icon
                              class="mr-3 primary--text"
                              @click="
                                releaseTable(
                                  floor.name,
                                  table.name,
                                  table.order
                                )
                              "
                              v-if="table.booked"
                            >
                              lock_open
                            </v-icon>
                            
                            <v-menu offset-y v-if="table.booked && table.order">
                              <template v-slot:activator="{ on }">
                                <v-btn v-on="on" icon class="mx-0">
                                  <v-icon class="mr-3 primary--text"
                                    >picture_as_pdf</v-icon
                                  >
                                </v-btn>
                              </template>
                              <v-list>
                                <v-list-tile
                                  @click="printOrder(table.order, true)"
                                >
                                  <v-list-tile-title>
                                    Taxable Print
                                  </v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile
                                  @click="printOrder(table.order, false)"
                                >
                                  <v-list-tile-title>
                                    Simple Print
                                  </v-list-tile-title>
                                </v-list-tile>
                              </v-list>
                            </v-menu>
                          </v-layout>
                        </v-list-item>
                      </v-card-actions>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-tab-item>
            </template>
          </v-tabs>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="primary" text @click="tableDialog = false">Back</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
        <v-dialog v-model="kitchenDialog" fullscreen persistent >
      <v-card >
        <v-card-title class="headline grey lighten-2" primary-title
          >Order Details
        </v-card-title>
        <v-card-text>
            <v-data-table
            :headers="kitchenOrderHeader"
            :items="getKetchenItems"
            class="elevation-1 dashboardHead"
          >
            <template slot="items" slot-scope="props">
              <tr
              >
                <td>
                  <b v-if="props.item.time">{{ new Date(props.item["time"]).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }) }}</b>
                </td>
                <td>
                  <b>{{ props.item["productName"] }}</b>
                </td>
                <td>
                  <b>{{ props.item["quantity"] }}</b>
                </td>
                <td>
                  <b>{{ props.item.order.tableName }}</b>
                </td>
                <td>
                  <b>{{ props.item.order.floorName }}</b>
                </td>
              </tr>
            </template>
            <template slot="no-data">No Items</template>
          </v-data-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="primary" text @click="kitchenDialog = false">Back</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
const mapBuyerGetters = createNamespacedHelpers("Buyer")["mapGetters"];
import { convertToOrder, convertToOrderWithoutGST } from "../../utils/orderPdf";
export default {
  data() {
    return {
      productsToOrder: [],
      items: [],
      isEdit: false,
      orderDialog: false,
      tableDialog: false,
      currentInfra: null,
      isBuyer: true,
      invoiceOrder: false,
      multiFirm: false,
      historyStep: 1,
      selectedOrder: null,
      selectedBuyer: null,
      selectedFirm: null,
      orderTime: null,
      soldBy: null,
      availableProductUnit: {},
      datepickerFrom : null,
      datepickerTo : null,
      dateTo : null,
      dateFrom : null,
      date: new Date().toISOString().substr(0, 10),
      time: new Date().getTime(),
      datepickerOrder: false,
      ordersSetting: null,
      statusFilter: "ALL",
      orderTypeFilter: "All",
      orderNumber: null,
      orderType: null,
      currentOrderType: ["Parcel", "Normal"],
      orderHistory: false,
      modalMode: null,
      floorName: null,
      tableName: null,
      isCallAdded: false,
      tableList: [],
      selectedCustomer: null,
      floorList: [],
      kitchenOrderHeader : [
        { text: "Time", value: "edit" },
        { text: "Item Name", value: "view" },
        { text: "Quantity", value: "orderNumber" },
        { text: "Table", value: "date" },
        { text: "Floor", value: "date" },
      ],
      kitchenDialog : false,
      orderHeader: [
        { text: "Action", value: "edit" },
        { text: "View", value: "view" },
        { text: "Table", value: "tableName", sortable: true },
        { text: "Order Number", value: "orderNumber" },
        { text: "Date", value: "date", sortable: true },
        { text: "Time", value: "time", sortable: true },
        { text: "Name", value: "name" },
        // { text: "Invoice No", value: "invoiceId" },
        { text: "Invoice Date", value: "date", sortable: true },
        { text: "Total Amount", value: "name" },
        // { text: "Remaining Order", value: "name" },
        // { text: "Order - ID", value: "deposit - ID" },
        // { text: "Firm", value: "product" },
        { text: "Status", value: "status" },
        { text: "Cancel Order", value: "cancelled" },
        { text: "Print", value: "print" },
        // { text: "Processed Order", value: "history" },
        // { text: "Original Order", value: "originalOrder" },
        // { text: "Edit", value: "edit" },
        // { text: "Delete", value: "edit" },
      ],
    };
  },
  created() {
        let start =  new Date().setHours(5, 30, 0, 0);
        let end  = new Date().setHours(23, 59, 59, 59);
        this.dateFrom = new Date(start).toISOString().substr(0, 10);
        this.dateTo = new Date(end).toISOString().substr(0, 10);
    this.$bindAsArray(
      "products",
      this.$root.$firebaseRefs.products
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    ),
      this.$bindAsArray(
        "buyers",
        this.$root.$firebaseRefs.buyer
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      ),
      this.$bindAsArray(
        "sellers",
        this.$root.$firebaseRefs.seller
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      ),
      this.$bindAsArray(
        "firms",
        this.$root.$firebaseRefs.firm
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      ),
      this.$bindAsArray(
        "orders",
        this.$root.$firebaseRefs.orders
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      ),
      this.$bindAsObject(
        "buyerById",
        this.$root.$firebaseRefs.buyer
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      ),
      this.$bindAsObject(
        "sellerById",
        this.$root.$firebaseRefs.seller
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      );
    this.$bindAsObject(
      "productById",
      this.$root.$firebaseRefs.products
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsArray(
      "termsAndConditions",
      this.$root.$firebaseRefs.termsAndConditions
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsObject(
      "bankById",
      this.$root.$firebaseRefs.account
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsArray(
      "firmInfrastructure",
      this.$root.$firebaseRefs.firmInfrastructure
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsArray(
      "orderSettings",
      this.$root.$firebaseRefs.orderSetting
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsArray(
      "staffs",
      this.$root.$firebaseRefs.staff
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    ),
      this.getCurrentSettings();
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand", "finYear","roleAndPermission"]),
    ...mapGlobalGetters({ units: "productUnit" }),
    hasOrderRateEditPermission(){
      if(this.roleAndPermission && 
      this.roleAndPermission.permissions && 
      this.roleAndPermission.permissions.length && 
      this.roleAndPermission.permissions.indexOf('ORDER_RATE_EDIT')>-1) {
        return true;
      } else {
        return false;
      }
    },
    hasOrderEditPermission(){
      if(this.roleAndPermission && 
      this.roleAndPermission.permissions && 
      this.roleAndPermission.permissions.length && 
      this.roleAndPermission.permissions.indexOf('INDIVIDUAL_ORDER_EDIT')>-1) {
        return true;
      } else {
        return false;
      }
    },
    hasOrderDeletePermission(){
      if(this.roleAndPermission && 
      this.roleAndPermission.permissions && 
      this.roleAndPermission.permissions.length && 
      this.roleAndPermission.permissions.indexOf('INDIVIDUAL_ORDER_DELETE')>-1) {
        return true;
      } else {
        return false;
      }
    },
    getKetchenItems(){
      let items = [];
      this.filteredOrders.map((order)=>{
        order.items && order.items.map((item)=>{
          let finalItem = JSON.parse(JSON.stringify(item));
          finalItem['order'] = order;
          items.push(finalItem);
        })
      })
      return items;
    },
    isTabOccupied() {
      let floorIndex = this.floorList.findIndex(
        (item) => item.name == this.floorName
      );
      if(this.floorList[floorIndex].tables) {
        let tableIndex = this.floorList[floorIndex].tables.findIndex(
        (item) => item.name == this.tableName
      );
        if(this.floorList[floorIndex].tables[tableIndex]) {
          return this.floorList[floorIndex].tables[tableIndex]["booked"];
        }
      }
      return false;
    },
    productListByBrand() {
      let prod = this.products.filter((item) => {
        return (
          item["brand"] === this.selectedBrand &&
          (!this.multiFirm
            ? this.selectedFirm
              ? item["firm"] === this.selectedFirm
              : false
            : true)
        );
      });
      prod.map((p, index) => {
        let productsWithSimilarCompostion = this.products.filter((item) => {
          return (
            item[".key"] == p[".key"] ||
            (item["brand"] === this.selectedBrand &&
              (!!item["composition"]
                ? _.isEqual(item["composition"], p["composition"])
                : false))
          );
        });
        prod[index]["similar"] = productsWithSimilarCompostion;
      });
      return prod;
    },
    staffByBrand() {
      return this.staffs
        .filter((item) => {
          return (
            item["brand"] === this.selectedBrand &&
            (!this.multiFirm
              ? this.selectedFirm
                ? item["firm"] === this.selectedFirm
                : false
              : true) &&
            item["staffRole"] === "Salesman"
          );
        })
        .map((item) => {
          return {
            text: item["staffName"],
            value: item[".key"],
          };
        });
    },
    filteredOrders() {
      let dateFrom =  new Date(this.dateFrom).setHours(0, 0, 0, 0);
      let dateTo  = new Date(this.dateTo).setHours(23, 59, 59, 59);
      return this.orders.filter((item) => {
        return (
          item["brand"] === this.selectedBrand &&
          (this.selectedCustomer
            ? item.buyerId == this.selectedCustomer
            : true) &&
          (this.statusFilter != "ALL"
            ? item.status == this.statusFilter
            : true) &&
          (this.orderTypeFilter != "All"
            ? item.orderType == this.orderTypeFilter
            : true) &&  
            ((this.dateFrom || this.dateTo) ? 
            (item.date>=dateFrom &&  item.date<=dateTo) : true) &&
          !item.isPortfolio
        );
      });
    },
    getOrderedCustomers() {
      return this.buyersByBrand.map((b) => {
        return {
          text: b.name,
          value: b[".key"],
        };
      });
    },
    buyersByBrand() {
      return this.buyers.filter((item) => {
        return item["brand"] === this.selectedBrand;
      });
    },
    sellersByBrand() {
      return this.sellers.filter((item) => {
        return item["brand"] === this.selectedBrand;
      });
    },
    firmsByBrand() {
      return this.firms
        .filter((item) => item["brand"] === this.selectedBrand)
        .map((item) => {
          if (item.defaultFirm) {
            this.selectedFirm = item[".key"];
          }
          return {
            text: item["name"],
            value: item[".key"],
          };
        });
    },
    isRestaurantBusiness() {
      if (this.selectedFirm) {
        let firm = this.firms.find((item) => item[".key"] == this.selectedFirm);
        if (firm.businessType == "Restaurant") {
          return true;
        }
      }
      return false;
    },
    // floorList() {
    //   if (this.selectedFirm) {
    //     let firmInfrastructure = this.firmInfrastructure.find(
    //       (item) => item["firm"] == this.selectedFirm
    //     );
    //     return firmInfrastructure.floorDetails;
    //   }
    //   return [];
    // },
    productInvoiceHeader() {
      let productInvoiceHeader = [
        { text: "Name", value: "Name" },
        { text: "Quantity", value: "Taxable" },
        { text: "Unit", value: "HSN" },
        { text: "Rate", value: "rate" },
        { text: "Total", value: "total" },
      ];
      if (this.isRestaurantBusiness) {
        productInvoiceHeader = [{ text: "Call", value: "call" }].concat(
          productInvoiceHeader
        );
      }
      return productInvoiceHeader;
    },
  },
  watch: {
    floorName: {
      handler(newVal, oldVal) {
        this.getTableList();
      },
      deep: true,
    },
    orderSettings: {
      handler(newVal, oldVal) {
        this.getCurrentSettings();
      },
      deep: true,
    },
    selectedFirm: {
      handler() {
        this.getFloorList();
      },
      deep: true,
    },
    tableName: {
      handler() {
        // if(!this.selectedOrder && this.tableName) {
        //   this.changeTableStatus(true)
        // }
      },
      deep: true,
    },
  },
  methods: {
    viewTable() {
      this.currentInfra = this.firmInfrastructure.find(
        (item) => item["firm"] == this.selectedFirm
      );
      this.currentInfra.floorDetails.map((f, i1) => {
        f.tables.map((t, i2) => {
          if (t.orderId) {
            this.currentInfra.floorDetails[i1].tables[i2]["order"] =
              this.orders.find((o) => o[".key"] == t.orderId);
          }
        });
      });
      this.tableDialog = true;
    },
    getOrders(order) {
      let calls = [];
      order.items && order.items.map((i) => {
        if (i.call && calls.indexOf(i.call) == -1) {
          calls.push(i.call);
        }
      });
      return calls;
    },
    getFloorList() {
      if (this.selectedFirm && this.firmInfrastructure.length) {
        let firmInfrastructure = JSON.parse(
          JSON.stringify(
            this.firmInfrastructure.find(
              (item) => item["firm"] == this.selectedFirm
            )
          )
        );
        this.floorList = [...firmInfrastructure.floorDetails];
      } else {
        this.floorList = [];
      }
    },
    releaseTable(floorName, tableName, order) {
      if (confirm("Are you sure?")) {
        let firmInfrastructure = JSON.parse(
          JSON.stringify(
            this.firmInfrastructure.find((item) => item["firm"] == (order ? order.firm : this.selectedFirm))
          )
        );
        // let floorIndex = firmInfrastructure.floorDetails.findIndex(
        //   (item) => item.name == floorName
        // );
        // let tableIndex = firmInfrastructure.floorDetails[
        //   floorIndex
        // ].tables.findIndex((item) => item.name == tableName);
        // firmInfrastructure.floorDetails[floorIndex].tables[tableIndex][
        //   "booked"
        // ] = false;
        // delete firmInfrastructure.floorDetails[floorIndex].tables[tableIndex][
        //   "orderId"
        // ];
        // delete firmInfrastructure.floorDetails[floorIndex].tables[tableIndex][
        //   "order"
        // ];
         firmInfrastructure.floorDetails.map(
          (floor,index) => {

            floor.tables.map((table,index2)=>{
              if(floor.name ==  floorName&& table.name == tableName) {
                   delete firmInfrastructure.floorDetails[index].tables[index2]["orderId"];
                   firmInfrastructure.floorDetails[index].tables[index2]["booked"] = false;
              }
              delete firmInfrastructure.floorDetails[index].tables[index2]["order"];
            }) 
          }
        )
        let key = firmInfrastructure[".key"];
        delete firmInfrastructure[".key"];
        this.$root.$firebaseRefs.firmInfrastructure
          .child(key)
          .set(firmInfrastructure)
          .then((snap) => {
            this.viewTable();
            this.getFloorList();
          });
      }
    },
    changeTableStatus(book) {
      let floorIndex = this.floorList.findIndex(
        (item) => item.name == this.floorName
      );
      let tableIndex = this.floorList[floorIndex].tables.findIndex(
        (item) => item.name == this.tableName
      );
      this.floorList[floorIndex].tables[tableIndex]["booked"] = book;
      if (!book) {
        delete this.floorList[floorIndex].tables[tableIndex]["orderId"];
      }
      this.floorList = [...this.floorList];
    },
    saveTableChanges(orderId) {
      let firmInfrastructure = this.firmInfrastructure.find(
        (item) => item["firm"] == this.selectedFirm
      );

      // let floorIndex = this.floorList.findIndex(
      //   (item) => item.name == this.floorName
      // );
      // let tableIndex = this.floorList[floorIndex].tables.findIndex(
      //   (item) => item.name == this.tableName
      // );
      this.floorList.map(
        (floor,index) => {

          floor.tables.map((table,index2)=>{
            if(floor.name == this.floorName && table.name == this.tableName) {
                 this.floorList[index].tables[index2]["orderId"] = orderId;
            }
            delete this.floorList[index].tables[index2]["order"];
          }) 
        }
      );
      //this.floorList[floorIndex].tables[tableIndex]["orderId"] = orderId;

      firmInfrastructure.floorDetails = this.floorList;
      let key = firmInfrastructure[".key"];
      delete firmInfrastructure[".key"];
      this.$root.$firebaseRefs.firmInfrastructure
        .child(key)
        .set(firmInfrastructure)
        .then((snap) => {
          if(this.tableDialog) {
            this.viewTable();
          }
        });
    },
    getCurrentSettings() {
      this.ordersSetting = this.orderSettings.find(
        (i) => i.brand == this.selectedBrand
      );
    },
    async printOrder(invoiceData, isGST, call) {
      let firm = this.firms.filter(
        (item) => item[".key"] === invoiceData["firm"]
      )[0];
      let customer = invoiceData.isBuyer
        ? this.buyerById[invoiceData.buyerId]
        : this.sellerById[invoiceData.buyerId];
      firm.address = this.getAddress(firm);
      customer.address = this.getAddress(customer);
      let termsAndConditions = this.getTermsAndConditions(invoiceData);
      let gstTotal = this.calculateGSTInvoice(customer, invoiceData, firm);
      if (isGST) {
        await convertToOrder({
          invoiceData: invoiceData,
          firm: firm,
          customer: customer,
          terms: termsAndConditions[0],
          gstTotal: gstTotal,
          call: call,
        }).then((doc) => {
          pdfMake.createPdf(doc).download();
        });
      } else {
        await convertToOrderWithoutGST({
          invoiceData: invoiceData,
          firm: firm,
          customer: customer,
          terms: termsAndConditions[0],
          gstTotal: gstTotal,
          call: call,
        }).then((doc) => {
          pdfMake.createPdf(doc).download();
        });
      }
    },
    getTermsAndConditions(invoiceData) {
      let termsAndConditions = this.termsAndConditions.filter(
        (item) =>
          item["brand"] === this.selectedBrand &&
          item["firm"] === invoiceData.firm
      );
      if (termsAndConditions.length) {
        if (termsAndConditions[0].bank) {
          let banks = [];
          termsAndConditions[0].bank.map((bankId) => {
            let bank = this.bankById[bankId];
            bank.address = this.getAddress(bank);
            banks.push(bank);
          });
          termsAndConditions[0].banks = banks;
        } else {
          termsAndConditions[0].banks = [];
        }
      } else {
        termsAndConditions = [
          {
            termsAndConditions: "",
            banks: [],
          },
        ];
      }
      return termsAndConditions;
    },
    getAddress(item) {
      if (!item) {
        return "";
      }
      let address =
        (item.village ? item.village + " - " : "") +
        (item.block ? item.block + " - " : "") +
        (item.tehsil ? item.tehsil + " - " : "") +
        (item.district ? item.district + " - " : "") +
        (item.state ? item.state + " - " : "") +
        (item.country ? item.country + " - " : "");
      address = address.substring(0, address.length - 2);
      return address;
    },
    calculateGSTInvoice(currentUser, invoice, firm) {
      let SGST_val = 0;
      let CGST_val = 0;
      let IGST_val = 0;
      invoice.items &&
        invoice.items.map((item, index) => {
          let prod = this.products.filter(
            (p) => p[".key"] === item["productId"]
          )[0];
          item["taxableGST_rate"] = prod["taxableGST_rate"];
          item.HSN_code = prod["HSN_code"];
          item.basicPrice = Number.parseFloat(
            item.rate * item.quantity
          ).toFixed(2);
          item.GSTValue = Number.parseFloat(
            item.basicPrice * (parseFloat(item.taxableGST_rate) / 100)
          ).toFixed(2);
          item.totlePrice = Number.parseFloat(
            Number.parseFloat(item.basicPrice) +
              Number.parseFloat(item.GSTValue)
          ).toFixed(2);
          let GST = item["taxableGST_rate"];
          if (
            !currentUser.state ||
            (firm &&
              currentUser.state &&
              Number.parseFloat(GST) &&
              firm.state === currentUser.state)
          ) {
            item["CGST_val"] = item["GSTValue"] / 2;
            item["CGST"] = GST / 2;
            item["SGST_val"] = item["GSTValue"] / 2;
            item["SGST"] = GST / 2;
            item["IGST"] = 0;
            item["IGST_val"] = 0;
          } else {
            item["IGST"] = GST;
            item["CGST"] = 0;
            item["SGST"] = 0;
            item["IGST_val"] = item["GSTValue"];
            item["CGST_val"] = 0;
            item["SGST_val"] = 0;
          }
          SGST_val += parseFloat(item["SGST_val"]);
          CGST_val += parseFloat(item["CGST_val"]);
          IGST_val += parseFloat(item["IGST_val"]);
        });
      return { SGST_val, CGST_val, IGST_val };
    },
    addOrderDialog(tableName,floorName) {
      if(tableName && floorName) {
        setTimeout(() => {
          this.floorName = floorName;
          this.tableName = tableName;
          this.orderType = 'Normal';
        }, 500);
      }
      this.orderDialog = true;
      this.productsToOrder = [];
      this.items = [
        {
          productName: null,
          productId: null,
          quantity: 1,
          unit: null,
          rate: 0,
          time: new Date().getTime()
        },
      ];
      this.time = new Date().getTime()
      this.isEdit = false;
      this.invoiceOrder = false;
      this.selectedBuyer = null;
      // this.selectedFirm = null;
      let orders = this.orders.filter(
        (i) => i["brand"] === this.selectedBrand
      );
      this.orderNumber = orders.length + 1;
      (this.orderType = null), (this.selectedOrder = null);
      this.floorName = null;
      this.tableName = null;
      this.isCallAdded = false;
      this.tableList = [];
      if (this.ordersSetting && this.ordersSetting.isOrderTime) {
        let date = new Date();
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var strTime = hours + ':' + minutes;
        this.orderTime = strTime;
      }
      this.getFloorList();
    },
    openHistory(item) {
      this.selectedOrder = item;
      this.orderHistory = true;
      this.historyStep = 1;
      this.modalMode = "history";
    },
    openOrignal(item) {
      this.selectedOrder = item;
      this.orderHistory = true;
      this.historyStep = 1;
      this.modalMode = "orignal";
    },
    openProd(item) {
      this.selectedOrder = item;
      this.invoiceOrder = true;
    },
    getTotal(item) {
      let total = 0;
      item.items && item.items.map((i) => {
        total += Number.parseFloat(
          Number.parseFloat(i.rate) * Number.parseFloat(i.quantity)
        );
      });
      return total;
    },
    getFirmName(e) {
      let firm;
      if (this.firms && this.selectedBrand) {
        firm = this.firms.filter((item) => item[".key"] === e)[0];
      }
      if (firm) return firm.name;
    },
    getCustomerName(id) {
      let buyer = this.buyerById[id];
      let seller = this.sellerById[id];
      if (!buyer && !seller) {
        return "DELETED CUSTOMER";
      }
      return buyer ? buyer.name : seller.name;
    },
    isShopUserExists(id) {
      let buyers = this.buyers.filter((item) => item.shopUserId == id);
      if (!buyers.length) {
        return false;
      }
      return true;
    },
    getShopUserName(id) {
      let buyers = this.buyers.filter((item) => item.shopUserId == id);
      if (!buyers.length) {
        return "DELETED CUSTOMER";
      }
      return buyers[0].name;
    },
    // addToBucket() {
    //   let tempIts = this.items;
    //   this.items = [];
    //   this.productsToOrder.map((prod, index) => {
    //     if (typeof prod == "string") {
    //       this.productsToOrder.splice(index, 1);
    //     }
    //   });
    //   this.productsToOrder.map((prod, index) => {
    //     let selectedProd = tempIts.filter(
    //       (item) => item["productId"] == prod[".key"]
    //     )[0];
    //     let itemToAdd = {
    //       productName: prod.name,
    //       similar: prod.similar,
    //       productId: prod[".key"],
    //       quantity:
    //         selectedProd && selectedProd.quantity ? selectedProd.quantity : 1,
    //       unit:
    //         selectedProd && selectedProd.unit ? selectedProd.unit : prod.unit,
    //       rate:
    //         selectedProd && selectedProd.rate
    //           ? selectedProd.rate
    //           : this.isBuyer
    //           ? prod["sellingPrice"] || 0
    //           : prod["purchasingPrice"] || 0,
    //     };
    //     if (this.multiFirm) {
    //       itemToAdd["firm"] = prod.firm;
    //     }
    //     this.items.push(itemToAdd);
    //   });
    // },
    restructureProductList(indexMain) {
      let buyer = this.selectedBuyer;
      this.items.map((item, index) => {
        if (indexMain ? index == indexMain : true) {
          let prod = this.products.filter(
            (item1) =>
              item1["name"] == item.productName &&
              item1["brand"] === this.selectedBrand
          )[0];

          this.items[index]["productName"] = prod.name;
          this.items[index]["productId"] = prod[".key"];
          this.items[index]["quantity"] = 1;
          this.items[index]["unit"] = prod.unit;
          this.items[index]["rate"] = this.isBuyer
            ? prod["sellingPrice"] || 0
            : prod["purchasingPrice"] || 0;
          if (prod.unitsDeatilsAdded) {
            this.availableProductUnit[prod[".key"]] = {
              units: prod.unitsDetails.map((prod) => {
                return prod.unit;
              }),
            };
          } else {
            this.availableProductUnit[prod[".key"]] = {
              units: this.units,
            };
          }
          if(buyer && buyer.category && prod.sellingPriceByCategories && prod.sellingPriceByCategories[buyer.category]) {
            this.items[index]['rate'] = prod.sellingPriceByCategories[buyer.category]
          }
          if (this.multiFirm) {
            this.items[index]["firm"] = prod.firm;
          }
          if (this.isRestaurantBusiness) {
            let call = 0;
            if (this.items.length > 1) {
              call = Math.max.apply(
                Math,
                this.items.map(function (o) {
                  return o.call || 0;
                })
              );
            }
            if (!this.isCallAdded) {
              call++;
              this.isCallAdded = !this.isCallAdded;
            }
            this.items[index]["call"] = call;
          }
        }
      });
    },
    getTableList() {
      if(this.floorName) {
        let floorList = this.floorList
        .find((item) => item.name == this.floorName);
        this.tableList = (floorList && floorList.tables ? 
        floorList.tables.filter((i) =>
          this.selectedOrder && this.selectedOrder[".key"]
            ? true
            : i.booked != true
        ) : []);
      }
    },
    addProd() {
      let itemToAdd = {
        productName: null,
        productId: null,
        quantity: 1,
        unit: null,
        rate: 0,
        time : new Date().getTime()
      };
      this.items.push(itemToAdd);
    },
    removeProd(index) {
      this.items.splice(index, 1);
    },
    getCurrentFirmState() {
      let firm = this.firms.filter(
        (item) => item[".key"] == this.selectedFirm
      )[0];
      return firm["state"];
    },
    addCustomer: function (e) {
      let obj = {
        name: e.target.value,
        brand: this.selectedBrand,
        state: this.getCurrentFirmState(),
      };
      if (this.isBuyer) {
        this.$root.$firebaseRefs.buyer.push(obj);
      } else {
        this.$root.$firebaseRefs.seller.push(obj);
      }
    },
    addShopUser(order) {
      if (confirm("Are you sure you want to create buyer?")) {
        let obj = {
          name: order.shopOrderUserName,
          shopUserId: order.shopOrderUserId,
          brand: this.selectedBrand,
          state: this.getCurrentFirmState(),
        };
        this.$root.$firebaseRefs.buyer.push(obj);
      }
    },
    createInvoice() {
      let key = this.selectedOrder[".key"];
      delete this.selectedOrder[".key"];

      if (!this.selectedOrder.buyerId && this.selectedOrder.shopOrderUserId) {
        let buyer = this.buyers.filter(
          (item) => item.shopUserId == this.selectedOrder.shopOrderUserId
        )[0];
        if (buyer) {
          this.selectedOrder["buyerId"] = buyer[".key"];
        } else {
          return;
        }
      }

      this.$root.$firebaseRefs.orders
        .child(key)
        .set(this.selectedOrder)
        .then((snap) => {
          this.selectedOrder = null;
          this.$router.push({ path: `/order-to-invoice/${key}` });
          this.invoiceOrder = false;
        });
    },
    cancelOrder(order) {
      if (window.confirm("Do you want to cancel this order?")) {
        let key = order[".key"];
        delete order[".key"];
        order["status"] = "CANCELLED";
        this.$root.$firebaseRefs.orders
          .child(key)
          .set(order)
          .then((snap) => {});
      }
    },
    editOrder(order) {
      if (order.multiFirm) {
        this.multiFirm = true;
      }
      if (order.orderTime) {
        this.orderTime = order.orderTime;
      }
      if (order.soldBy) {
        this.soldBy = order.soldBy;
      }
      this.productsToOrder = [];
      this.items = order.items;
      this.selectedFirm = order.firm;
      (this.date = new Date(order.date).toISOString().substr(0, 10)),
      (this.time = new Date(this.time).getTime()),
        (this.orderNumber = order.orderNumber),
        (this.orderType = order.orderType),
        (this.selectedOrder = order);
      this.isBuyer = order.isBuyer;
      if (order.isBuyer) {
        this.selectedBuyer = this.buyerById[order.buyerId];
      } else {
        this.selectedBuyer = this.sellerById[order.buyerId];
      }
      if (this.isRestaurantBusiness && this.orderType === 'Normal') {
        this["floorName"] = order.floorName;
        this["tableName"] = order.tableName;
      }
      this.items.map((item, index) => {
        let prod = this.products.filter(
          (item1) =>
            item1["name"] == item.productName &&
            item1["brand"] === this.selectedBrand
        )[0];

        if (prod.unitsDeatilsAdded) {
          this.availableProductUnit[prod[".key"]] = {
            units: prod.unitsDetails.map((prod) => {
              return prod.unit;
            }),
          };
        } else {
          this.availableProductUnit[prod[".key"]] = {
            units: this.units,
          };
        }
      });

      this.orderDialog = true;
      this.isEdit = true;

      // this.items.map((item1,index)=>{
      //   let productsWithSimilarCompostion = this.products.filter((item) => {
      //   return (item['.key'] == item1['productId'] || (item['brand'] === this.selectedBrand && (!!item['composition'] ?
      //     _.isEqual(item['composition'],item1['composition']) : false)
      //     ))
      //   });
      //   this.items[index]['similar'] = productsWithSimilarCompostion;
      //   // this.productsToOrder.push(this.productById[item1.productId])
      //   let obj = this.productById[item1.productId];
      //   obj['.key'] = item1.productId;
      //   let sim = this.products.filter((item) => {
      //   return (item['.key'] ==obj['.key'] || (item['brand'] === this.selectedBrand && (!!item['composition'] ?
      //     _.isEqual(item['composition'],obj['composition']) : false)
      //     ))
      //   });
      //   obj['similar'] = sim;
      //   this.productsToOrder.push(obj)
      // })
    },
    unitChange(item) {
      let prod = this.products.find((i) => i[".key"] == item["productId"]);
      if (prod.unitsDeatilsAdded) {
        prod.unitsDetails.map((prod) => {
          if (prod["unit"] == item.unit) {
            let rate = this.isBuyer
              ? prod["sellingPrice"]
              : prod["purchasingPrice"];
            if (rate) {
              item.rate = rate;
            }
          }
        });
      }
    },
    addOrder() {
      this.items.map((i, index) => {
        if (!i.productName) {
          this.items.splice(index, 1);
        }
      });
      let orderObj = {
        buyerId: this.selectedBuyer[".key"],
        isBuyer: this.isBuyer,
        firm: this.selectedFirm,
        brand: this.selectedBrand,
        date: new Date(this.date).getTime(),
        time: new Date(this.time).getTime(),
        orderNumber: this.orderNumber,
        orderType: this.orderType,
        items: this.items,
      };
      //   status: 'IN PROGRESS'
      // }
      // this.$root.$firebaseRefs.orders.push(orderObj);
      if (this.multiFirm) {
        orderObj["multiFirm"] = true;
      }
      if (this.isRestaurantBusiness) {
        orderObj["floorName"] = this.floorName;
        orderObj["tableName"] = this.tableName;
      }
      if (this.ordersSetting && this.ordersSetting.isOrderTime) {
        orderObj["orderTime"] = this.orderTime;
      }
      if (this.ordersSetting && this.ordersSetting.isStaffSelection) {
        orderObj["soldBy"] = this.soldBy;
      }
      let key = null;
      if (this.isEdit) {
        key = this.selectedOrder[".key"];
        orderObj["status"] = this.selectedOrder["status"];
        orderObj["buyerId"] = this.selectedOrder["buyerId"];
        this.$root.$firebaseRefs.orders
          .child(this.selectedOrder[".key"])
          .set(orderObj)
          .then((snap) => {
            this.isEdit = false;
          });
      } else {
        orderObj["status"] = "IN PROGRESS";
        let res = this.$root.$firebaseRefs.orders.push(orderObj);
        key = res.key;
      }
      this.isCallAdded = false;
      this.orderDialog = false;
      this.selectedBuyer = null;
      this.isBuyer = true;
      this.items = [];
      this.productsToOrder = [];
      if (this.isRestaurantBusiness) {
        this.saveTableChanges(key);
        if(this.isEdit && this.tableDialog) {
          this.viewTable();
        }
      } 
    },
    deleteOrder(order) {
      if (window.confirm("Do you want to Delete ?")) {
        this.$root.$firebaseRefs.orders.child(order[".key"]).remove();
      }
    },
  },
};
</script>
<style>
.status-filter.v-select .v-select__selections,
.status-filter.v-icon {
  color: #fff !important;
}
.status-filter.v-text-field > .v-input__control > .v-input__slot:before {
  border-color: #fff;
}

</style>
<style scoped>
.invoice-stepper {
  border: 1px solid #01579b;
  border-radius: 4px;
  background: #fafafa;
}
.green-bg {
  background: #d7ffd7;
}
.lightgreen-bg {
  background: #8bf88b;
  border: 4px solid #fafafa;
  border-radius: 3px;
  border-collapse: separate;
  border-spacing: 1px;
}

.white-datepicker .v-icon,
.white-datepicker .v-label,
.white-datepicker input {
  color: white !important;
}
.white-datepicker .v-icon,
.white-datepicker .v-label,
.white-datepicker input {
  color: white !important;
}

.white-datepicker .v-input__slot:before {
  border-color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/components/RecordOrder/recordOrder.vue